module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0048.png.233966f8.jpg";